// The post-case engagement survey.
//
// Three questions, deliberately mixed: one behavioural (did you take part),
// one about perceived readiness (did it land), and one open text (what moved).
// Two scales make the dashboard comparable across cases; the text answer is
// what actually tells you why a number moved.
//
// These are DEFAULTS ONLY, the facilitator edits the live set in the admin
// dashboard, which stores them under archives/_surveys/config/questions.
// Editing them there never touches this file.

export const QUESTION_TYPES = [
  ['scale', '1–5 scale'],
  ['choice', 'Multiple choice'],
  ['text', 'Free text'],
];

export const SCALE_MIN = 1;
export const SCALE_MAX = 5;

export const DEFAULT_QUESTIONS = [
  {
    id: 'contribution',
    order: 0,
    type: 'scale',
    prompt: "How actively did you contribute to the group's reasoning today?",
    low: 'Mostly listened',
    high: 'Contributed throughout',
  },
  {
    id: 'confidence',
    order: 1,
    type: 'scale',
    prompt: 'How confident would you feel working up this presentation on your own now?',
    low: 'Not confident',
    high: 'Very confident',
  },
  {
    id: 'takeaway',
    order: 2,
    type: 'text',
    prompt: "What's one thing that changed your thinking today, or one thing still unclear?",
  },
];

// Firebase stores questions as a keyed map; the UI wants an ordered array.
export const toQuestionList = (node) => {
  const list = Object.entries(node || {}).map(([id, q]) => ({
    id,
    order: 0,
    type: 'scale',
    prompt: '',
    ...q,
    options: Array.isArray(q?.options) ? q.options : [],
  }));
  return list.length
    ? list.sort((a, b) => (a.order ?? 0) - (b.order ?? 0) || a.id.localeCompare(b.id))
    : DEFAULT_QUESTIONS.map((q) => ({ options: [], ...q }));
};

export const toQuestionMap = (list) => {
  const out = {};
  (list || []).forEach((q, i) => {
    if (!q.id || !(q.prompt || '').trim()) return;
    out[q.id] = {
      order: i,
      type: q.type || 'scale',
      prompt: q.prompt.trim(),
      ...(q.type === 'scale' ? { low: (q.low || '').trim(), high: (q.high || '').trim() } : {}),
      ...(q.type === 'choice' ? { options: (q.options || []).filter(Boolean) } : {}),
    };
  });
  return out;
};

// Keys must be Firebase-safe and stable, the dashboard groups answers by them.
export const slugifyId = (prompt, taken = []) => {
  const base = (prompt || 'question')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 32) || 'question';
  let id = base;
  let n = 2;
  while (taken.includes(id)) { id = `${base}-${n}`; n += 1; }
  return id;
};
